import { create } from "zustand";

type State = {
  show: boolean;
};

type Action = {
  setShow: (trigger: boolean) => void;
};

const useKubuBanner = create<State & Action>((set) => ({
  show: true,
  setShow: (newPost) => set(() => ({ show: newPost })),
}));

export default useKubuBanner;
